document.addEventListener('DOMContentLoaded', () => {
    const textItems = document.querySelectorAll('.scroll-text .text');

    if (!textItems.length) return;

    textItems[0].classList.add('is-active');

    const isMobile = window.innerWidth <= 768;
    const observerOptions = {
        root: null,
        rootMargin: isMobile ? '-70% 0px -25% 0px' : '-55% 0px -55% 0px',
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const currentItem = entry.target;

                currentItem.classList.add('is-active');
                currentItem.classList.remove('is-viewed');

                let prev = currentItem.previousElementSibling;
                while (prev && prev.classList.contains('text')) {
                    prev.classList.add('is-viewed');
                    prev.classList.remove('is-active');
                    prev = prev.previousElementSibling;
                }

                let next = currentItem.nextElementSibling;
                while (next && next.classList.contains('text')) {
                    next.classList.remove('is-active');
                    next.classList.remove('is-viewed');
                    next = next.nextElementSibling;
                }
            }
        });
    }, observerOptions);

    textItems.forEach(item => observer.observe(item));
});

document.addEventListener('DOMContentLoaded', () => {
    const specialistLinks = document.querySelectorAll('.section-data-agent .specialist .image, .btn');

    specialistLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            const targetUrl = this.closest('a') ? this.closest('a').getAttribute('href') : null;

            if (targetUrl && targetUrl !== '#') {
                e.preventDefault();

                this.classList.add('is-clicked');

                setTimeout(() => {
                    window.location.href = targetUrl;
                }, 600);
            }
        });
    });
});